import { RadioButton, RadioButtonGroup } from 'carbon-components-react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'src/apps/watsonx-orchestrate-self-assessment/locales/messages';
import { QuesIDProps } from '../../WatsonxOrchestrateSelfAssessment';
import { segmentsTracking } from 'src/common/lib/tracker';
import { points } from 'src/apps/watsonx-orchestrate-self-assessment/constants/default';

type Step2Props = {
  pathSelected: string;
  que2Value: string;
  setQue2Value: React.Dispatch<React.SetStateAction<string>>;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  trackQuesID: QuesIDProps;
  que2Points: number;
  setQue2Points: React.Dispatch<React.SetStateAction<number>>;
};

const Step2 = ({
  pathSelected,
  que2Value,
  setQue2Value,
  setTrackQuesID,
  trackQuesID,
  que2Points,
  setQue2Points,
}: Step2Props) => {
  const handleClick = (
    value: string,
    event: React.MouseEvent<HTMLInputElement>,
    points: number,
  ) => {
    setQue2Points(points);
    setQue2Value(value);
    setTrackQuesID({
      ...trackQuesID,
      Q2:
        pathSelected === 'Non-Tech'
          ? intl.formatMessage(messages.NonTech_2_question)
          : intl.formatMessage(messages.Tech_2_question),
    });
    segmentsTracking('CTA Clicked', {
      pageTitle: 'Watsonx Orchestrate Self Assessment',
      object: 'Watsonx Orchestrate Self Assessment page',
      resultValue: 'CTA clicked',
      CTA: 'Q2 answer selection',
      location: `${pathSelected} Path Selection`,
      action: value,
      field: '',
    });
  };
  const intl = useIntl();

  return (
    <div>
      {pathSelected === 'Non-Tech' ? (
        <div>
          <div className="page_sub_heading padding_8">
            <FormattedMessage {...messages.NonTech_2_question} />
          </div>
          <RadioButtonGroup
            name="Q2-NonTech-group"
            defaultSelected="NTQ2A1"
            valueSelected={que2Value}
            orientation="vertical"
          >
            <RadioButton
              labelText={intl.formatMessage(messages.NonTech_2_ans1)}
              value={intl.formatMessage(messages.NonTech_2_ans1)}
              id="NTQ2A1"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.NonTech_2_ans1),
                  e,
                  points.Q2A1,
                )
              }
            />
            <RadioButton
              labelText={intl.formatMessage(messages.NonTech_2_ans2)}
              value={intl.formatMessage(messages.NonTech_2_ans2)}
              id="NTQ2A2"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.NonTech_2_ans2),
                  e,
                  points.Q2A2,
                )
              }
            />
            <RadioButton
              labelText={intl.formatMessage(messages.NonTech_2_ans3)}
              value={intl.formatMessage(messages.NonTech_2_ans3)}
              id="NTQ2A3"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.NonTech_2_ans3),
                  e,
                  points.Q2A3,
                )
              }
            />
            <RadioButton
              labelText={intl.formatMessage(messages.NonTech_2_ans4)}
              value={intl.formatMessage(messages.NonTech_2_ans4)}
              id="NTQ2A4"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.NonTech_2_ans4),
                  e,
                  points.Q2A4,
                )
              }
            />
            <RadioButton
              labelText={intl.formatMessage(messages.NonTech_2_ans5)}
              value={intl.formatMessage(messages.NonTech_2_ans5)}
              id="NTQ2A5"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.NonTech_2_ans5),
                  e,
                  points.Q2A5,
                )
              }
            />
          </RadioButtonGroup>
        </div>
      ) : (
        <div>
          <div className="page_sub_heading padding_8">
            <FormattedMessage {...messages.Tech_2_question} />
          </div>
          <RadioButtonGroup
            name="Q2-Tech-group"
            defaultSelected="TQ2A1"
            valueSelected={que2Value}
            orientation="vertical"
          >
            <RadioButton
              labelText={intl.formatMessage(messages.Tech_2_ans1)}
              value={intl.formatMessage(messages.Tech_2_ans1)}
              id="TQ2A1"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.Tech_2_ans1),
                  e,
                  points.Q2A1,
                )
              }
            />
            <RadioButton
              labelText={intl.formatMessage(messages.Tech_2_ans2)}
              value={intl.formatMessage(messages.Tech_2_ans2)}
              id="NTQ2A2"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.Tech_2_ans2),
                  e,
                  points.Q2A2,
                )
              }
            />
            <RadioButton
              labelText={intl.formatMessage(messages.Tech_2_ans3)}
              value={intl.formatMessage(messages.Tech_2_ans3)}
              id="NTQ2A3"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.Tech_2_ans3),
                  e,
                  points.Q2A3,
                )
              }
            />
            <RadioButton
              labelText={intl.formatMessage(messages.Tech_2_ans4)}
              value={intl.formatMessage(messages.Tech_2_ans4)}
              id="NTQ2A4"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.Tech_2_ans4),
                  e,
                  points.Q2A4,
                )
              }
            />
            <RadioButton
              labelText={intl.formatMessage(messages.Tech_2_ans5)}
              value={intl.formatMessage(messages.Tech_2_ans5)}
              id="NTQ2A5"
              onClick={(e) =>
                handleClick(
                  intl.formatMessage(messages.Tech_2_ans5),
                  e,
                  points.Q2A5,
                )
              }
            />
          </RadioButtonGroup>
        </div>
      )}
    </div>
  );
};

export default Step2;
